import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, unref as _unref, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ONYX-Logo-Black-Colour-X.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "log-in-box" }
const _hoisted_3 = { class: "error-message" }
const _hoisted_4 = { class: "password-field" }
const _hoisted_5 = ["type"]
const _hoisted_6 = { class: "show-password-button" }
const _hoisted_7 = ["disabled"]

import { ref } from "vue";
import VueFeather from "vue-feather";
import { InvalidCredentialsError } from "@/errors/errors";
import { postLogin } from "@/helpers/api";
import { setAuthToken, refreshRoles, isExternalUser } from "@/helpers/store";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter();

const login = async () => {
  try {
    const response = await postLogin(username.value, password.value);
    setAuthToken(response.AuthToken);
    await refreshRoles();
    router.push(isExternalUser() ? "/external" : "/");
  } catch (error) {
    if (error instanceof InvalidCredentialsError) {
      errorMessage.value = error.message;
    }
  }
};

const username = ref("");
const password = ref("");
const errorMessage = ref("");
const showPassword = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "logo",
        src: _imports_0,
        height: "80"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(errorMessage.value), 1),
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "username-label",
        for: "username-field"
      }, "Username", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "username-field",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
        onKeyup: _withKeys(login, ["enter"])
      }, null, 544), [
        [_vModelText, username.value]
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        class: "password-label",
        for: "password-field"
      }, "Password", -1)),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          id: "password-field",
          type: showPassword.value ? 'text' : 'password',
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          onKeyup: _withKeys(login, ["enter"])
        }, null, 40, _hoisted_5), [
          [_vModelDynamic, password.value]
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createVNode(_unref(VueFeather), {
            type: showPassword.value ? 'eye-off' : 'eye'
          }, null, 8, ["type"]),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "hidden",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPassword).value = $event))
          }, null, 512), [
            [_vModelCheckbox, showPassword.value]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-success login-button",
        title: "Log in",
        onClick: login,
        disabled: !username.value || !password.value
      }, " Log in ", 8, _hoisted_7)
    ])
  ]))
}
}

})